<div class="dropdown-container">
  <!-- Cabeçalho clicável -->
  <div class="dropdown-header" (click)="onToggle()">
    <div class="header-content">
      <div class="text-content">
        <h3 class="title">{{ title }}</h3>
        <p class="subtitle" [class.visible]="isOpen">{{ subtitle }}</p>
      </div>
      <div class="icon-container">
        <svg
          [class.rotated]="isOpen"
          class="arrow-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Conteúdo da tabela -->
  <div class="dropdown-content" [class.open]="isOpen">
    <app-leads-table
      [columns]="tableColumns"
      [data]="tableData"
      [filterConfig]="filterConfig"
      [serverSidePagination]="serverSidePagination"
      [loading]="loading"
      [emptyMessage]="emptyMessage"
      [errorMessage]="errorMessage"
      [viewButtonTracking]="viewButtonTracking"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (viewLeadClick)="onViewLead($event)"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"
      (clearAllFilters)="onClearAllFilters()"
      (sortChange)="onSortChange($event)"
    ></app-leads-table>
  </div>
</div>
